import select from 'dom-select';

// The mobile menu button. The menu sits before the button in the page, so while it's open the
// rest of the page is made inert (Tab stays in the menu and the button), focus moves into the
// menu, and Escape closes it and returns focus to the button.
export const MenuToggle = (el) => {
  const ui = {
    el,
    nav: select('.js-navigation', document),
    body: select('body', document),
  };

  const outside = () => [select('main', document), select('.global-footer', document)].filter(Boolean);

  const setOpen = (open, { returnFocus = false } = {}) => {
    ui.el.classList.toggle('is-active', open);
    ui.el.setAttribute('aria-expanded', String(open));
    ui.body.classList.toggle('nav-active', open);

    if (ui.nav) {
      ui.nav.classList.toggle('is-active', open);
      ui.body.classList.toggle('nav-open', open);
    }

    outside().forEach((node) => {
      if (open) node.setAttribute('inert', '');
      else node.removeAttribute('inert');
    });

    if (open) {
      // The menu fades in; it only becomes focusable once that transition has started.
      const first = ui.nav && select('.nav-item', ui.nav);
      if (first) requestAnimationFrame(() => requestAnimationFrame(() => first.focus()));
    } else if (returnFocus) {
      ui.el.focus();
    }
  };

  const isOpen = () => ui.el.classList.contains('is-active');

  const addEvents = () => {
    ui.el.addEventListener('click', () => {
      setOpen(!isOpen());
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && isOpen()) {
        setOpen(false, { returnFocus: true });
      }
    });

    // Widening past the desktop breakpoint hides the button; never leave the page inert then.
    // Matches media-queries.large (80rem).
    const desktop = window.matchMedia('(min-width: 80rem)');
    desktop.addEventListener('change', (event) => {
      if (event.matches && isOpen()) setOpen(false);
    });
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default MenuToggle;
